<div class="card widget-card">
  <div class="card-header widget-card-header">
    <div class="widget-card-heading">
      <h2 class="card-title">
        @if (config().icon) {
          <app-icon [name]="config().icon!" [size]="16" />
        }
        {{ config().title }}
      </h2>
      @if (config().subtitle) {
        <div class="card-sub">{{ config().subtitle }}</div>
      }
    </div>
    <div class="widget-card-action">
      <ng-content select="[cardAction]" />
    </div>
  </div>

  <div class="card-body widget-card-body">
    @if (loading()) {
      @if (config().skeleton; as blocks) {
        <app-widget-skeleton [blocks]="blocks" />
      } @else {
        <div class="widget-card-skeleton">
          @for (row of skeletonRows; track row) {
            <app-skeleton height="18px" />
          }
        </div>
      }
    } @else if (error()) {
      <div class="widget-card-state widget-card-error">
        <app-icon name="warning" [size]="18" />
        <p class="widget-card-state-text">{{ error() }}</p>
        <button type="button" class="btn btn-soft btn-sm" (click)="retry.emit()">
          <app-icon name="refresh" [size]="14" />
          Try again
        </button>
      </div>
    } @else if (empty()) {
      <!--
        One line, left-aligned, in the reading order of the rows it stands in for — a centred paragraph
        in the middle of a tall card spends the card's whole height saying that there is nothing in it.
      -->
      <div class="widget-card-quiet">
        @if (config().emptyIcon ?? config().icon; as icon) {
          <span class="widget-card-quiet-icon"><app-icon [name]="icon" [size]="15" /></span>
        }
        <p class="widget-card-quiet-text">{{ config().emptyText ?? 'Nothing to show yet.' }}</p>
        @if (config().emptyAction; as action) {
          <a class="widget-card-quiet-link" [routerLink]="action.link">{{ action.label }} &rarr;</a>
        }
      </div>
    } @else {
      <ng-content />
    }
  </div>
</div>
